import { render } from "./BanUserModal.vue?vue&type=template&id=b595c376&scoped=true"
import script from "./BanUserModal.vue?vue&type=script&lang=js"
export * from "./BanUserModal.vue?vue&type=script&lang=js"

import "./BanUserModal.vue?vue&type=style&index=0&id=b595c376&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b595c376"]])

export default __exports__